import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, Platform } from '@ionic/angular';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  LocalUser: any;
  activePageTitle = 'Dashboard';
  Pages = [
    {
      title: 'Çağrılar',
      url: '/tabs/home',
      icon: 'alarm-outline'
    },
    {
      title: 'MGB',
      url: '/tabs/mgb-home',
      icon: 'calendar-outline'
    },
 /*   {
      title: 'Survey',
      url: '/tabs/survey-home',
      icon: 'pencil-outline'
    },
    {
      title: 'Checklist',
      url: '/tabs/checklist',
      icon: 'checkmark-done-outline'
    },*/
    {
      title: 'Lokasyon',
      url: '/tabs/rooms',
      icon: 'business-outline'
    },
  /*  {
      title: 'Güvenlik',
      url: '/security-home',
      icon: 'car-outline'
    },*/
    {
      title: 'Ayarlar',
      url: '/tabs/settings',
      icon: 'settings-outline'
    },
  ];
  constructor(
    private platform: Platform,  private router: Router,  private authService: AuthService, private menuController: MenuController
  ) {
  //  this.initializeApp();

  }
  /*initializeApp() {
    this.platform.ready().then(() => {
   
    });
  }*/
  /*initializeApp() {
    this.platform.ready().then(() => {
      this.oneSignal.startInit('ff431b60-ee15-4e6b-a5a1-e1cb9dec9fc8');
  
      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
  
      this.oneSignal.handleNotificationReceived().subscribe((data) => {
        console.log('Bildirim alındı:', data);
      });
  
      this.oneSignal.handleNotificationOpened().subscribe((data) => {
        console.log('Bildirim açıldı:', data);
      });
  
      // iOS için kullanıcıdan izin isteme
      this.oneSignal.promptForPushNotificationsWithUserResponse().then(granted => {
        console.log('Push izin durumu:', granted);
        if (!granted) {
          alert('Lütfen bildirim iznini etkinleştir!');
        }
      });
  
      this.oneSignal.endInit();
    });
  }*/
  
  

  getInitials(name: string): string {
    if (!name) {
      return '';
    }

    const initials = name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('');

    return initials;
  }

  logout() {
    this.authService.removeToken(); 
    this.menuController.close();
  }

  
}